import React from 'react';
import { createStaticMapsUrl } from '@vis.gl/react-google-maps';
import { appConfig } from 'config/app';

export const useJobsiteStaticMapUrl = (
  latitude?: number,
  longitude?: number,
): string | null => {
  return React.useMemo((): string | null => {
    return latitude && longitude
      ? createStaticMapsUrl({
          apiKey: appConfig.googleMapsApiKey,
          width: 512,
          height: 512,
          center: { lat: latitude, lng: longitude },
          zoom: 15,
        })
      : null;
  }, [latitude, longitude]);
};
